/* eslint-disable */
<template>
  <div class="rotate-wrapper">
    <!-- <button
      style="position: fixed; z-index: 100000; top: 10px; left: 20px"
      @click="getState"
    >
      获取状态
    </button> -->
    <div class="rotate-content">
      <iframe
        ref="gameIframe"
        :src="gameSrc"
        frameborder="0"
        allowfullscreen
        @load="iframeOnload"
        :class="{ 'landscape-iframe': isScreenOrientation }"
      ></iframe>
      <div
        class="mouse-circle"
        :style="{ left: `${circleX}px`, top: `${circleY}px` }"
        v-if="!isStart"
      ></div>
      <div
        class="mouse-circle"
        :style="{ left: `${circleX}px`, top: `${circleY}px` }"
        v-if="isStart && allMouse"
      ></div>
      <div
        class="handle-box"
        :class="{ 'landscape-handle': isScreenOrientation }"
        v-if="!isStart"
      >
        <div class="handle-btn">
          {{ language === "zh" ? "摇杆选择" : "CONTROLLER SELECT" }}
        </div>
        <div class="handle-btn">
          [ A ] {{ language === "zh" ? "确认" : "confirmation" }}
        </div>
      </div>
      <!-- <div
        class="handle-box start-handle"
        :class="{ 'landscape-start': isScreenOrientation }"
        v-if="isStart && allMouse"
      >
        <div class="handle-btn">
          {{ language === "zh" ? "摇杆选择" : "CONTROLLER SELECT" }}
        </div>
        <div class="handle-btn">
          [ A ] {{ language === "zh" ? "确认" : "confirmation" }}
        </div>
      </div> -->
      <div
        class="rotate"
        :class="{ 'landscape-rotate': isScreenOrientation }"
        v-if="screenOrientation === 1"
        @click="changeRotate"
      >
        <img src="../../assets/img/rotate.png" alt="" />
      </div>
    </div>
    <!-- 提示没收到数据弹框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" class="message-dialog">
      <div class="message-close" @click="dialogVisible = false">
        <img src="../../assets/img/message-close.png" alt="" />
      </div>
      <div class="message-box">
        <img src="../../assets/img/message-error.png" alt="" />
        <p>长时间未收到数据，请返回App重新连接蓝牙</p>
        <div class="message-btn">
          <p @click="dialogVisible = false">
            <img src="../../assets/img/message-cancel.png" alt="" />
            <span>取消</span>
          </p>
          <p @click="enterEsc">
            <img src="../../assets/img/message-btn.png" alt="" /><span
              >确认</span
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGameDetails } from "@/api/game";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      webGameType: 0,
      gameSrc: "",
      id: "",
      coordinate: [],
      // 保存模拟键盘方向键
      currentHeldKey: "",
      // 摇杆控制鼠标xy
      circleX: 100,
      circleY: 100,
      minCircleX: 0,
      maxCircleX: 0,
      minCircleY: 0,
      maxCircleY: 0,
      canvasWidth: 0,
      canvasHeight: 0,
      // 点击改变xy
      clickX: 0.5,
      clickY: 0.2,
      // 游戏是否开始
      isStart: false,
      startNumber: 0,
      gameStatusName: "",
      gameStatusSheetName: "",
      isPause: false, // 暂停
      allMouse: false,
      isAHeld: false, // 是否按住 A 键
      bKeyLock: false,
      noDataTimer: null,
      noDataTimeout: 10000, // 10秒无数据提醒
      isNoDataAlertShown: false,
      timerVersion: 0, // ✅ 新增唯一版本标记
      screenOrientation: 0,
      isReady: false,
      isScreenOrientation: false,
      isRotate: false,
      dialogVisible: false,

      // 判断游戏状态
      startTimer: null,
      // 是否在加载完成之后更新游戏状态
      watchTimer: null,
      previousCanvasState: null,
      canvasChangeCount: 0, // 🆕 变化计数器
    };
  },
  async created() {},
  mounted() {},
  computed: {
    ...mapGetters(["key", "joystick", "language"]),
  },
  activated() {
    this.init();
    this.setupGyroDataReceiver();
  },
  deactivated() {
    window.__vueUnityHandler = null;
    this.isScreenOrientation = false;
    if (this.noDataTimer) {
      clearTimeout(this.noDataTimer);
      this.noDataTimer = null;
    }
    if (this.startTimer) {
      clearTimeout(this.startTimer);
      this.startTimer = null;
    }
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
      this.updateTimer = null;
    }
    if (this.watchTimer) {
      clearTimeout(this.watchTimer);
      this.watchTimer = null;
    }
    this.timerVersion++;
    this.isStart = false;
    this.startNumber = 0;
  },
  watch: {
    key: {
      handler(newVal, oldVal) {
        const isHold = JSON.stringify(newVal) === JSON.stringify(oldVal);
        const coordinate = this.coordinate.filter(
          (el) => el.name === "ismouse"
        );
        // console.log(newVal, 111, oldVal);
        if (newVal.includes("A")) {
          if (isHold) {
            // 持续按住 A，不重复触发
            return;
          }

          // 首次按下 A
          if (this.isStart && coordinate.length > 0) {
            this.allMouse = true;
            // 鼠标模式，计算相对坐标
            const x = Math.min(
              Math.max(
                (this.circleX - this.minCircleX + 10) / this.canvasWidth,
                0
              ),
              1
            );
            const y = Math.min(
              Math.max(
                (this.circleY - this.minCircleY + 10) / this.canvasHeight,
                0
              ),
              1
            );
            if (this.isScreenOrientation) {
              this.startRuntimePress(1 - y, x);
            } else {
              this.startRuntimePress(x, y);
            }
          } else {
            // 非鼠标控制，走原逻辑
            this.keyAGame();
          }
        } else {
          // A键松开
          this.releaseRuntimePress();
        }
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          // if (newVal.indexOf("A") !== -1) {
          //   this.keyAGame();
          // }
          if (newVal.indexOf("R") !== -1) {
            this.keyRGame();
          }
          if (newVal.indexOf("B") !== -1) {
            this.keyBGame();
          }
          if (newVal.indexOf("X") !== -1) {
            this.keyXGame();
          }
          if (newVal.indexOf("L") !== -1) {
            this.keyLGame();
          }
          if (newVal.indexOf("ZL") !== -1) {
            this.keyZLGame();
          }
          if (newVal.indexOf("ZR") !== -1) {
            this.keyZRGame();
          }
          if (newVal.indexOf("Y") !== -1) {
            this.keyYGame();
          }
        }
      },
      deep: true, // 必须加上才能触发对象/数组内部变动
    },
    joystick: {
      handler(newVal) {
        this.moveMouse(newVal);
      },
      deep: true, // 必须加上才能触发对象/数组内部变动
    },
  },
  methods: {
    changeRotate() {
      if (this.isStart) return;
      this.isScreenOrientation = !this.isScreenOrientation;
      setTimeout(() => {
        this.iframeOnload();
      }, 300);
    },
    sendDataToUnity(value) {
      location.href = `uniwebview://vue-message?type=${value}`;
    },
    setupGyroDataReceiver() {
      window.__vueUnityHandler = (data) => {
        try {
          const parsedData = typeof data === "string" ? JSON.parse(data) : data;
          if (parsedData.type === "sensorData") {
            this.resetNoDataTimer(); // 每次收到数据时重置定时器
            this.filterAndUpdateSensorData(parsedData.gamepadData);
          }
        } catch (error) {
          console.error("❌ 解析 UniApp 数据失败:", error);
        }
      };
      this.resetNoDataTimer(); // 回到首页重启监听
    },
    resetNoDataTimer() {
      this.timerVersion++;
      const currentVersion = this.timerVersion;
      // 清除之前定时器
      if (this.noDataTimer) {
        clearTimeout(this.noDataTimer);
      }
      this.isNoDataAlertShown = false; // 收到数据，重置提醒状态

      // 设置新定时器
      this.noDataTimer = setTimeout(() => {
        // console.log("⏰ 触发 showNoDataAlert 定时器");
        if (this.timerVersion !== currentVersion) {
          console.log("🚫 定时器版本已过期，跳过 alert");
          return; // 如果版本不一致，说明被新定时器覆盖
        }
        this.showNoDataAlert();
      }, this.noDataTimeout);
    },
    showNoDataAlert() {
      if (this.isNoDataAlertShown) return;
      this.isNoDataAlertShown = true;
      this.dialogVisible = true;
    },
    enterEsc() {
      this.sendDataToUnity("Close");
      this.dialogVisible = false;
    },
    filterAndUpdateSensorData(value) {
      this.$store.dispatch("delData", value);
    },
    // 初始化
    async init() {
      const query = this.$route.query;
      this.id = query.id;
      this.gameSrc = query.src;
      this.webGameType = Number(query.type);
      this.screenOrientation = Number(query.screenOrientation);
      // await this.$nextTick();
      // setTimeout(() => {
      //   this.isReady = true; // 此时再显示 iframe
      // }, 100); // 可根据情况调整延迟时间
      const res = await getGameDetails({ id: this.id });
      this.coordinate = JSON.parse(res.result);
      this.allMouse = false;
      this.isStart = false;
      this.isPause = false;
      this.isRotate = false;
      // const updateCoordinate = this.coordinate.filter(
      //   (el) => el.name === "updatecoordinates"
      // );
      // if (updateCoordinate.length > 0) {
      // this.updateTimer =
      this.startWatchingSplash();
      // }
    },
    startWatchingSplash() {
      if (this.watchTimer) return; // 防止重复设置定时器
      this.canvasChangeCount = 0; // 每次开始都重置
      this.previousCanvasState = null;

      this.watchTimer = setInterval(() => {
        console.log(1111);
        const iframe = this.$refs.gameIframe;
        const iframeWindow = iframe?.contentWindow;
        if (!iframeWindow) return;
        const gameStatus = iframeWindow.cr_getC2Runtime().running_layout?.name;

        if (gameStatus) {
          console.log("gameStatus", gameStatus);
          this.iframeOnload();
          console.log("加载完毕，去除定时器！");
          clearInterval(this.watchTimer);
          this.watchTimer = null;
          return;
        }
        // console.log(iframeWindow.cr_getC2Runtime());
        for (const key in iframeWindow.cr_getC2Runtime()) {
          const prop = iframeWindow.cr_getC2Runtime()[key];
          // console.log(prop.name);
          if (prop && typeof prop === "object" && prop.name) {
            console.log(`可能的布局属性: ${key}`, prop.name);
            this.iframeOnload();
            console.log("加载完毕，去除定时器！");
            clearInterval(this.watchTimer);
            this.watchTimer = null;
          }
        }
      }, 1000);
    },
    iframeOnload() {
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe.contentWindow;
      if (!iframeWindow) {
        console.warn("iframe.contentWindow 为 null");
        return;
      }

      const canvas = iframeWindow.document.getElementById("c2canvas");
      if (!canvas) {
        console.warn("找不到 canvas！");
        return;
      }
      const rect = canvas.getBoundingClientRect();
      if (this.isScreenOrientation) {
        const canvasWidth = Math.min(rect.height, window.innerWidth);
        const canvasHeight = Math.min(rect.width, window.innerHeight);
        this.minCircleX = rect.top;
        this.maxCircleX = rect.top + canvasWidth - 30;
        this.minCircleY = rect.left;
        this.maxCircleY = rect.left + canvasHeight - 30;
        this.circleX = rect.top;
        this.circleY = this.maxCircleY;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
      } else {
        const canvasWidth = Math.min(rect.width, window.innerWidth);
        const canvasHeight = Math.min(rect.height, window.innerHeight);
        this.minCircleX = rect.left;
        this.maxCircleX = rect.left + canvasWidth - 30;
        this.minCircleY = rect.top;
        this.maxCircleY = rect.top + canvasHeight - 30;
        this.circleX = rect.left;
        this.circleY = rect.top;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
      }
    },
    // 获取游戏状态
    getState() {
      const coordinate = this.coordinate.filter((el) => el.name === "ismouse");
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe.contentWindow.cr_getC2Runtime();
      if (iframeWindow.running_layout) {
        const { name, sheetname } = iframeWindow.running_layout;
        this.gameStatusName = name;
        this.gameStatusSheetName = sheetname;
        console.log("name:", name, "sheetname:", sheetname, 1111);
        this.startTimer = setTimeout(() => {
          this.getState();
        }, 100);
        if (name === "Game" && sheetname === "Game_Event") {
          this.isStart = true;
          return;
        }
        if (sheetname === "GameEvent") {
          this.isStart = true;
          return;
        }
        if (name === "Game" && sheetname === "GameSettings") {
          this.isStart = true;
          return;
        }
        if (name === "SceneLayout" && sheetname === "SceneEventSheet") {
          this.isStart = true;
          return;
        }
        if (
          name === "StartMenu" &&
          sheetname === "AddSettings" &&
          coordinate.length > 0
        ) {
          this.isStart = true;
          this.allMouse = true;
          return;
        }
        if (name === "Game" && sheetname === "Game Sheet") {
          this.isStart = true;
          return;
        }
        if (name.indexOf("Level") !== -1 && sheetname === "Game_Event") {
          this.isStart = true;
          return;
        }
        if (name.indexOf("Level") !== -1 && sheetname === "Game_Sheet") {
          this.isStart = true;
          return;
        }
        if (name.indexOf("Level") !== -1 && sheetname === "GameEventSheet") {
          this.isStart = true;
          return;
        }
        if (name === "Game" && sheetname.indexOf("Event sheet") !== -1) {
          this.isStart = true;
          return;
        }
        if (
          name === "Selector" &&
          sheetname === "Selector" &&
          coordinate.length > 0
        ) {
          this.isStart = true;
          this.allMouse = true;
          return;
        }
        if (name.indexOf("Nivel") !== -1 && sheetname === "ControlNivel") {
          this.isStart = true;
          return;
        }
        if (name.indexOf("Level") !== -1 && sheetname.indexOf("Level") !== -1) {
          this.isStart = true;
          return;
        }
        this.isStart = false;
        if (this.startTimer) {
          clearTimeout(this.startTimer);
          this.startTimer = null;
        }
      } else {
        // const runtime = iframeWindow.cr_getC2Runtime?.();
        // console.log(iframeWindow);
        for (const key in iframeWindow) {
          const prop = iframeWindow[key];
          if (prop && typeof prop === "object" && prop.name) {
            console.log(
              `可能的布局属性: ${key}---`,
              prop.name,
              this.isStart,
              this.isPause
            );
            this.startTimer = setTimeout(() => {
              this.getState();
            }, 100);
            if (prop.name === "LevelSelection") {
              this.isStart = false;
              if (this.startTimer) {
                clearTimeout(this.startTimer);
                this.startTimer = null;
              }
              return;
            }
            if (prop.name.indexOf("Level") !== -1) {
              this.isStart = true;
              return;
            }
            if (
              prop.name === "game" ||
              prop.name === "Game" ||
              prop.name === "Main" ||
              prop.name.indexOf("Layout") !== -1
            ) {
              this.isStart = true;
              return;
            }
            this.isStart = false;
            if (this.startTimer) {
              clearTimeout(this.startTimer);
              this.startTimer = null;
            }
          }
        }
      }
    },
    // A键相关
    async keyAGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "ismouse");
      // 游戏开始
      if (this.isStart && coordinate.length === 0) {
        // 游戏中暂停
        if (this.isPause) {
          // 继续游戏
          this.goonGame();
          return;
        }
        if (this.webGameType === 1) {
          const coordinate1 = this.coordinate.filter(
            (el) => el.name === "showmouse"
          );
          const coordinate2 = this.coordinate.filter(
            (el) => el.name === "aIsR"
          );
          if (coordinate2.length > 0) {
            this.moveGame("ArrowRight");
            return;
          }
          if (coordinate1.length > 0) {
            const x = Math.min(
              Math.max(
                (this.circleX - this.minCircleX + 10) / this.canvasWidth,
                0
              ),
              1
            );
            const y = Math.min(
              Math.max(
                (this.circleY - this.minCircleY + 10) / this.canvasHeight,
                0
              ),
              1
            );
            console.log(x, y, 111);

            if (this.isScreenOrientation) {
              this.getRuntime(1 - y, x);
            } else {
              this.getRuntime(x, y);
            }
            const coordinate2 = this.coordinate.filter(
              (el) => el.name === "cut"
            );
            if (coordinate2.length > 0) {
              console.log(11111111111);
              this.spaceGame();
            }
            return;
          }
          // 模拟空格
          this.spaceGame();
        } else {
          // 模拟点击
          this.clickGame();
        }
        return;
      }
      if (this.isStart && coordinate.length > 0) {
        this.allMouse = true;
      }
      // 游戏未开始 判断是否竖屏
      if (this.isScreenOrientation) {
        const x = Math.min(
          Math.max((this.circleX - this.minCircleX + 10) / this.canvasWidth, 0),
          1
        );
        const y = Math.min(
          Math.max(
            (this.circleY - this.minCircleY + 10) / this.canvasHeight,
            0
          ),
          1
        );
        const coordinate3 = this.coordinate.filter(
          (el) => el.name === "specific"
        );
        if (coordinate3.length > 0) {
          this.getRuntime(1 - y, x);
        } else {
          this.getRuntime(y, x);
        }
      } else {
        const x = Math.min(
          Math.max((this.circleX - this.minCircleX + 10) / this.canvasWidth, 0),
          1
        );
        const y = Math.min(
          Math.max(
            (this.circleY - this.minCircleY + 10) / this.canvasHeight,
            0
          ),
          1
        );
        // console.log(x, y, 111);
        this.getRuntime(x, y);
      }
    },
    // R键相关
    async keyRGame() {
      if (this.isStart) {
        const coordinate2 = this.coordinate.filter((el) => el.name === "rIsL");
        if (coordinate2.length > 0) {
          this.moveGame("ArrowLeft");
          return;
        }
        // 暂停游戏
        this.pauseGame();
        return;
      }
    },
    // B键相关
    async keyBGame() {
      console.log(this.bKeyLock, this.isStart, this.isPause);
      if (this.bKeyLock) return; // 锁定期间不响应
      this.bKeyLock = true;
      if (this.isStart && this.isPause) {
        // 返回游戏菜单
        console.log("返回游戏菜单");
        const coordinate = this.coordinate.filter((el) => el.name === "home");
        if (coordinate.length > 0) {
          this.backHomeGame(coordinate[0].x, coordinate[0].y);
        } else {
          // console.log(2222);
          this.$router.go(-1);
        }
        setTimeout(() => {
          this.bKeyLock = false;
        }, 1000);
        return;
      }
      const coordinate1 = this.coordinate.filter(
        (el) => el.name === "gameoverhome"
      );
      if (this.isStart && coordinate1.length > 0) {
        console.log("返回游戏菜单");
        // 返回游戏菜单
        // if (this.isScreenOrientation) {
        //   this.backHomeGame(coordinate1[0].y, coordinate1[0].x);
        // } else {

        this.backHomeGame(coordinate1[0].x, coordinate1[0].y);
        setTimeout(() => {
          this.bKeyLock = false;
        }, 1000);
        // }
        return;
      }
      console.log("返回列表");
      // this.bKeyLock = true;
      this.$router.go(-1);
      setTimeout(() => {
        this.bKeyLock = false;
      }, 1000);
    },
    // X键相关
    async keyXGame() {
      if (this.isStart && this.isPause) {
        const coordinate = this.coordinate.filter(
          (el) => el.name === "restart"
        );
        // 重新开始
        this.restartGame(coordinate[0].x, coordinate[0].y);
        return;
      }
      const coordinate1 = this.coordinate.filter(
        (el) => el.name === "gameoverrestart"
      );
      // console.log(coordinate1[0].y, coordinate1[0].x, this.isStart, 222);
      if (this.isStart && coordinate1.length > 0) {
        // console.log(coordinate1[0].y, coordinate1[0].x, 111);
        // 返回游戏菜单
        // if (this.isScreenOrientation) {
        //   this.backHomeGame(coordinate1[0].y, coordinate1[0].x);
        // } else {
        this.backHomeGame(coordinate1[0].x, coordinate1[0].y);
        // }
        return;
      }
      const coordinate2 = this.coordinate.filter(
        (el) => el.name === "startover"
      );
      this.getRuntime(coordinate2[0].x, coordinate2[0].y);
    },
    // L键相关
    async keyLGame() {
      if (this.isStart && !this.isPause) {
        // 操作道具
        this.propGame();
        return;
      }
      // this.$router.go(-1);
    },
    // ZL相关
    async keyZLGame() {
      if (this.isStart && !this.isPause) {
        // 向左
        this.leftGame();
        return;
      }
      // this.$router.go(-1);
    },
    // ZR相关
    async keyZRGame() {
      if (this.isStart && !this.isPause) {
        // 向右
        this.rightGame();
        return;
      }
      // this.$router.go(-1);
    },
    // Y相关
    async keyYGame() {
      if (this.isStart && this.isPause) {
        const coordinate = this.coordinate.filter((el) => el.name === "save");
        // 保存游戏
        this.saveGame(coordinate[0].x, coordinate[0].y);
        return;
      }
      if (this.screenOrientation === 0) return;
      if (this.isRotate) return;
      this.isRotate = true;
      this.changeRotate();
      setTimeout(() => {
        this.isRotate = false;
      }, 500);
    },
    // 摇杆控制
    moveMouse(value) {
      const coordinate = this.coordinate.filter((el) => el.name === "ismouse");
      if (this.isStart && coordinate.length === 0) {
        if (this.webGameType === 1) {
          // 摇杆模拟键盘上下左右
          this.moveAction(value);
          const coordinate1 = this.coordinate.filter(
            (el) => el.name === "showmouse"
          );
          if (coordinate1.length > 0) {
            this.allMouse = true;
            if (this.isScreenOrientation) {
              this.circleX -= value.y * 8;
              this.circleX = Math.min(
                Math.max(this.circleX, this.minCircleX),
                this.maxCircleX
              );
              this.circleY -= value.x * 8;
              this.circleY = Math.min(
                Math.max(this.circleY, this.minCircleY),
                this.maxCircleY
              );
              // console.log(this.circleY);
            } else {
              this.circleX += value.x * 8;
              this.circleX = Math.min(
                Math.max(this.circleX, this.minCircleX),
                this.maxCircleX
              );
              this.circleY -= value.y * 8;
              this.circleY = Math.min(
                Math.max(this.circleY, this.minCircleY),
                this.maxCircleY
              );
            }
          }
        }
        return;
      }
      const coordinate2 = this.coordinate.filter(
        (el) => el.name === "speediness"
      );
      if (coordinate2.length > 0) {
        // console.log(2222);
        this.circleX += value.x * 12;
        this.circleX = Math.min(
          Math.max(this.circleX, this.minCircleX),
          this.maxCircleX
        );
        this.circleY -= value.y * 12;
        this.circleY = Math.min(
          Math.max(this.circleY, this.minCircleY),
          this.maxCircleY
        );
        return;
      }
      if (this.isScreenOrientation) {
        this.circleX -= value.y * 8;
        this.circleX = Math.min(
          Math.max(this.circleX, this.minCircleX),
          this.maxCircleX
        );
        this.circleY -= value.x * 8;
        this.circleY = Math.min(
          Math.max(this.circleY, this.minCircleY),
          this.maxCircleY
        );
        // console.log(this.circleY);
      } else {
        this.circleX += value.x * 8;
        this.circleX = Math.min(
          Math.max(this.circleX, this.minCircleX),
          this.maxCircleX
        );
        this.circleY -= value.y * 8;
        this.circleY = Math.min(
          Math.max(this.circleY, this.minCircleY),
          this.maxCircleY
        );
      }
      if (this.isAHeld) {
        const iframe = this.$refs.gameIframe;
        const iframeWindow = iframe.contentWindow;
        if (!iframeWindow) return;

        const canvas = iframeWindow.document.getElementById("c2canvas");
        if (!canvas) return;
        const mouseMoveEvent = new iframeWindow.MouseEvent("mousemove", {
          bubbles: true,
          cancelable: true,
          clientX: this.circleX,
          clientY: this.circleY,
          buttons: 1, // 左键保持按下
        });
        canvas.dispatchEvent(mouseMoveEvent);
      }
    },
    // 暂停游戏
    async pauseGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "pause");
      if (coordinate.length > 0) {
        await this.getRuntime(coordinate[0].x, coordinate[0].y);
        this.isPause = true;
        return;
      }
    },
    // 继续游戏
    async goonGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "goon");
      if (coordinate.length > 0) {
        await this.getRuntime(coordinate[0].x, coordinate[0].y);
        this.isPause = false;
      }
    },
    // 返回游戏菜单
    async backHomeGame(x, y) {
      // const coordinate = this.coordinate.filter((el) => el.name === "home");
      // if (coordinate.length > 0) {
      await this.getRuntime(x, y);
      this.isPause = false;
      this.isStart = false;
      // }
    },
    // 重新开始游戏
    async restartGame(x, y) {
      // const coordinate = this.coordinate.filter((el) => el.name === "restart");
      // if (coordinate.length > 0) {
      await this.getRuntime(x, y);
      this.isPause = false;
      this.isStart = false;
      // }
    },
    // 保存游戏
    async saveGame(x, y) {
      await this.getRuntime(x, y);
      this.isPause = false;
    },
    // 操作道具
    async propGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "prop");
      if (coordinate.length > 0) {
        await this.getRuntime(coordinate[0].x, coordinate[0].y);
      }
    },
    // 向左
    async leftGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "left");
      if (coordinate.length > 0) {
        this.clickX = Math.max(0, this.clickX - 0.1);
        await this.getRuntime(this.clickX, this.clickY);
      }
      // 切换道具
      const coordinate1 = this.coordinate.filter((el) => el.name === "ZL");
      if (coordinate1.length > 0) {
        await this.getRuntime(coordinate1[0].x, coordinate1[0].y);
      }
    },
    // 向右
    async rightGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "right");
      if (coordinate.length > 0) {
        this.clickX = Math.min(1, this.clickX + 0.1);
        await this.getRuntime(this.clickX, this.clickY);
      }
      // 切换道具
      const coordinate1 = this.coordinate.filter((el) => el.name === "ZR");
      if (coordinate1.length > 0) {
        await this.getRuntime(coordinate1[0].x, coordinate1[0].y);
      }
    },
    // 摇杆操作
    moveAction(value) {
      const coordinate = this.coordinate.filter(
        (el) => el.name === "disableLandR"
      );
      if (coordinate.length > 0) {
        if (value.y < -0.5) {
          this.moveGame("ArrowDown");
        } else if (value.y > 0.5) {
          this.moveGame("ArrowUp");
        }
        if (Math.abs(value.x) < 0.5 && Math.abs(value.y) < 0.5) {
          this.releaseGameKey(this.currentHeldKey);
        }
        return;
      }
      if (value.x < -0.5) {
        this.moveGame("ArrowLeft");
      } else if (value.x > 0.5) {
        this.moveGame("ArrowRight");
      }
      // } else {
      if (value.y < -0.5) {
        this.moveGame("ArrowDown");
      } else if (value.y > 0.5) {
        this.moveGame("ArrowUp");
      }
      if (Math.abs(value.x) < 0.5 && Math.abs(value.y) < 0.5) {
        this.releaseGameKey(this.currentHeldKey);
      }
    },
    // A键操作 空格操作
    async spaceGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "space");
      if (coordinate.length > 0) {
        this.moveGame(" ");
        return;
      }
      const coordinate1 = this.coordinate.filter((el) => el.name === "click");
      if (coordinate1.length > 0) {
        await this.getRuntime(coordinate1[0].x, coordinate1[0].y);
        return;
      }
    },
    // A键 模拟点击
    async clickGame() {
      const coordinate = this.coordinate.filter((el) => el.name === "click");
      if (coordinate.length > 0) {
        await this.getRuntime(coordinate[0].x, coordinate[0].y);
      }
    },
    drawDebugDot(canvas, relativeX, relativeY) {
      const rect = canvas.getBoundingClientRect();
      // console.log(rect.left, rect.top, rect.width, rect.height);
      const x = rect.left + rect.width * relativeX;
      const y = rect.top + rect.height * relativeY;

      const dot = document.createElement("div");
      dot.style.position = "fixed";
      dot.style.width = "8px";
      dot.style.height = "8px";
      dot.style.background = "red";
      dot.style.border = "1px solid white";
      dot.style.borderRadius = "50%";
      dot.style.left = x + "px";
      dot.style.top = y + "px";
      dot.style.zIndex = 9999;
      dot.style.pointerEvents = "none"; // 不影响点击事件
      document.body.appendChild(dot);

      setTimeout(() => dot.remove(), 1200);
    },
    getRuntime(relativeX, relativeY) {
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe.contentWindow;
      if (!iframeWindow) {
        console.warn("iframe.contentWindow 为 null");
        return;
      }
      const canvas = iframeWindow.document.getElementById("c2canvas");

      if (!canvas) {
        console.warn("找不到 canvas！");
        return;
      }

      // try {
      // 创建并派发 TouchEvent
      //   const touch = new iframeWindow.Touch({
      //     identifier: Date.now(),
      //     target: canvas,
      //     clientX: x,
      //     clientY: y,
      //     pageX: x,
      //     pageY: y,
      //     screenX: x,
      //     screenY: y,
      //   });

      //   const touchEvent = new iframeWindow.TouchEvent("touchstart", {
      //     bubbles: true,
      //     cancelable: true,
      //     touches: [touch],
      //     targetTouches: [touch],
      //     changedTouches: [touch],
      //   });

      //   canvas.dispatchEvent(touchEvent);
      //   // console.log("TouchEvent 触发完成");
      // } catch (e) {
      //   console.warn("触发 TouchEvent 失败，可能被浏览器限制：", e);
      // }
      const rect = canvas.getBoundingClientRect();
      const x = rect.left + rect.width * relativeX;
      const y = rect.top + rect.height * relativeY;
      // this.drawDebugDot(canvas, relativeX, relativeY);

      // 创建并派发 MouseEvent (mousedown + mouseup)
      const mouseDownEvent = new iframeWindow.MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        clientX: x,
        clientY: y,
        button: 0, // 左键
      });
      canvas.dispatchEvent(mouseDownEvent);

      // 模拟真实点击，延迟触发 mouseup
      setTimeout(() => {
        const mouseUpEvent = new iframeWindow.MouseEvent("mouseup", {
          bubbles: true,
          cancelable: true,
          clientX: x,
          clientY: y,
          button: 0,
        });
        canvas.dispatchEvent(mouseUpEvent);
        // console.log("MouseEvent mousedown + mouseup 触发完成");
      }, 50);
      // this.getState();
      if (!this.startTimer) {
        this.getState();
      }
    },
    // 按住A键模拟按下点击
    startRuntimePress(relativeX, relativeY) {
      // console.log(relativeX, relativeY);
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe.contentWindow;
      if (!iframeWindow) {
        console.warn("iframe.contentWindow 为 null");
        return;
      }
      const canvas = iframeWindow.document.getElementById("c2canvas");

      if (!canvas) {
        console.warn("找不到 canvas！");
        return;
      }

      const rect = canvas.getBoundingClientRect();
      const x = rect.left + rect.width * relativeX;
      const y = rect.top + rect.height * relativeY;

      // this.drawDebugDot(canvas, relativeX, relativeY);

      if (this.isAHeld) return;
      const mouseDownEvent = new iframeWindow.MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        clientX: x,
        clientY: y,
        button: 0,
      });
      canvas.dispatchEvent(mouseDownEvent);

      this.aHoldPosition = { x, y };
      this.isAHeld = true;

      // this.getState();
      if (!this.startTimer) {
        this.getState();
      }
    },

    // 松开A键触发 mouseup
    releaseRuntimePress() {
      if (!this.isAHeld || !this.aHoldPosition) return;

      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe.contentWindow;
      if (!iframeWindow) {
        console.warn("iframe.contentWindow 为 null");
        return;
      }
      const canvas = iframeWindow.document.getElementById("c2canvas");

      const { x, y } = this.aHoldPosition;

      const mouseUpEvent = new iframeWindow.MouseEvent("mouseup", {
        bubbles: true,
        cancelable: true,
        clientX: x,
        clientY: y,
        button: 0,
      });
      canvas.dispatchEvent(mouseUpEvent);

      this.isAHeld = false;
      this.aHoldPosition = null;

      // this.getState();
      if (!this.startTimer) {
        this.getState();
      }
    },
    moveGame(keyChar) {
      const isHoldKey = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
      ].includes(keyChar);

      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDocument = iframe?.contentDocument || iframeWindow?.document;
      if (!iframeDocument) return;

      let keyCode = 0;
      let code = "";
      switch (keyChar) {
        case " ":
          keyCode = 32;
          code = "Space";
          break;
        case "i":
          keyCode = 73;
          code = "KeyI";
          break;
        case "k":
          keyCode = 75;
          code = "KeyK";
          break;
        case "j":
          keyCode = 74;
          code = "KeyJ";
          break;
        case "l":
          keyCode = 76;
          code = "KeyL";
          break;
        case "ArrowUp":
          keyCode = 38;
          code = "ArrowUp";
          break;
        case "ArrowDown":
          keyCode = 40;
          code = "ArrowDown";
          break;
        case "ArrowLeft":
          keyCode = 37;
          code = "ArrowLeft";
          break;
        case "ArrowRight":
          keyCode = 39;
          code = "ArrowRight";
          break;
        default:
          keyCode = keyChar.toUpperCase().charCodeAt(0);
          code = "Key" + keyChar.toUpperCase();
      }

      // 自动释放上一个方向键
      if (isHoldKey && this.currentHeldKey && this.currentHeldKey !== keyChar) {
        this.releaseGameKey(this.currentHeldKey);
      }

      // 发送新的 keydown
      const keydownEvent = new KeyboardEvent("keydown", {
        key: keyChar,
        code,
        keyCode,
        which: keyCode,
        bubbles: true,
        cancelable: true,
      });
      iframeDocument.dispatchEvent(keydownEvent);

      if (isHoldKey) {
        this.currentHeldKey = keyChar;
      } else {
        const keyupEvent = new KeyboardEvent("keyup", {
          key: keyChar,
          code,
          keyCode,
          which: keyCode,
          bubbles: true,
          cancelable: true,
        });
        setTimeout(() => {
          iframeDocument.dispatchEvent(keyupEvent);
        }, 100);
      }
      // this.getState();
      if (!this.startTimer) {
        this.getState();
      }
    },

    releaseGameKey(keyChar) {
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDocument = iframe?.contentDocument || iframeWindow?.document;
      if (!iframeDocument) return;

      let keyCode = 0;
      let code = "";
      switch (keyChar) {
        case "ArrowUp":
          keyCode = 38;
          code = "ArrowUp";
          break;
        case "ArrowDown":
          keyCode = 40;
          code = "ArrowDown";
          break;
        case "ArrowLeft":
          keyCode = 37;
          code = "ArrowLeft";
          break;
        case "ArrowRight":
          keyCode = 39;
          code = "ArrowRight";
          break;
      }

      const keyupEvent = new KeyboardEvent("keyup", {
        key: keyChar,
        code,
        keyCode,
        which: keyCode,
        bubbles: true,
        cancelable: true,
      });
      iframeDocument.dispatchEvent(keyupEvent);

      // 清除状态
      if (this.currentHeldKey === keyChar) {
        this.currentHeldKey = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* 横屏旋转容器 */
.rotate-wrapper {
  position: absolute;
  transform-origin: center center;
  overflow: hidden;
  // background: black;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}
.landscape-mode {
  transform: rotate(-90deg);
  width: 100vh;
  height: 100vw;
}
.rotate-content {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.landscape-mode .rotate-content {
  width: 100vh;
  height: 100vw;
}
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.landscape-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vh;
  height: 100vw;
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
}
.landscape-mode iframe {
  transform-origin: center center;
  border: none;
}
.rotate {
  position: absolute;
  z-index: 1000;
  left: 1%;
  top: 1%;
  img {
    width: 70px;
  }
}
.landscape-rotate {
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
  top: 85%;
}
.handle-box {
  position: absolute;
  z-index: 1000;
  left: 70%;
  top: 1%;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px 26px;
  border-radius: 48px;
}
.start-handle {
  top: 88%;
}
.landscape-handle {
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
  left: 1%;
}
.landscape-start {
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
  top: 0;
  left: 80%;
}
.handle-btn {
  font-weight: bold;
  font-size: 22px;
  color: #000000;
  line-height: 1;
  margin-left: 10px;
}

.mouse-circle {
  position: absolute;
  z-index: 1000;
  background: rgba(225, 57, 10, 0.8);
  width: 36px;
  height: 36px;
  border-radius: 100%;
  border: 6px solid rgba(52, 14, 241, 0.2);
}
</style>
